var _style, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYandexDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 118,
    height: 24,
    viewBox: "0 0 255.3 52",
    style: {
      enableBackground: "new 0 0 255.3 52"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FC3F1D;}\n\t.st1{fill:#FFFFFF;}\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 24,
    cy: 24,
    r: 24
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M27.2,13.6H25c-4.1,0-6.2,2.1-6.2,5.1c0,3.4,1.5,5,4.5,7.1l2.5,1.7l-7.2,10.8h-5.4l6.5-9.6 c-3.7-2.7-5.8-5.3-5.8-9.6c0-5.5,3.8-9.2,11.1-9.2h7.2v28.5h-5V13.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5,49.4v-7.5h18.1v7.5h5.9V37h-3.4V5.8h-21l-0.5,14.9C63.3,29.2,62.7,34.2,61,37h-2.3v12.4H64.5z M69.1,21.5l0.4-10.8 h9.4V37h-12C68,34.5,68.8,30,69.1,21.5z M101.9,15.2c-6.8,0-11.5,4.8-11.5,13.6c0,8.7,4.7,13.6,11.5,13.6s11.6-4.8,11.6-13.6 C113.5,20.1,108.7,15.2,101.9,15.2z M101.9,37.5c-3.4,0-5.1-2.7-5.1-8.7c0-6.1,1.7-8.7,5.1-8.7s5.2,2.6,5.2,8.7 S105.4,37.5,101.9,37.5z M128.9,42.4c2.9,0,4.9-0.5,6.4-1.6v-5c-1.6,1.1-3.4,1.8-6,1.8c-4.4,0-6.2-3.4-6.2-8.8 c0-5.7,2.2-8.6,6.3-8.6c2.4,0,4.7,0.8,6,1.6v-5.2c-1.3-0.7-3.6-1.2-6.7-1.2c-7.9,0-12,5.7-12,13.6C116.6,37.6,120.6,42.4,128.9,42.4 z M158.6,20.6v-4.9h-20.7v4.9h7.3v21.3h6.2V20.6H158.6z M180.2,24.1c0-6.3-3.2-8.7-9.8-8.7c-4.1,0-7.3,1.3-9.2,2.4V23 c1.7-1.2,5.3-2.6,8.5-2.6c3,0,4.3,1,4.3,3.8v1.5h-1c-9.5,0-13.7,3.1-13.7,8.4s3.2,8.3,8,8.3c3.6,0,5.2-1.2,6.4-2.4h0.3 c0.1,0.7,0.3,1.6,0.5,2.1h6c-0.2-2.1-0.3-4.3-0.3-6.4V24.1z M174.1,35.7c-0.8,1.1-2.2,2.1-4.4,2.1c-2.6,0-3.9-1.6-3.9-3.9 c0-3.1,2.1-4.2,7.4-4.2h0.9V35.7z M195.5,41.9c6.1,0,9.8-2.6,9.8-7.6c0-3.4-2.1-5.4-5.6-6c2.8-0.8,4.6-2.8,4.6-5.9 c0-4.5-3-6.7-8.7-6.7h-10.4v26.2C185.2,41.9,195.5,41.9,195.5,41.9z M194.7,20.4c2.2,0,3.5,0.9,3.5,2.9c0,1.8-1.3,2.9-3.7,2.9h-3.1 v-5.8C191.4,20.4,194.7,20.4,194.7,20.4z M194.9,30.8c2.6,0,4,0.9,4,3.1c0,2.4-1.6,3.3-4,3.3h-3.4v-6.4 C191.5,30.8,194.9,30.8,194.9,30.8z M224.8,41.9h7l-9.9-14.1l8.7-12.1h-6.2l-8.7,12.1V15.7h-6.2v26.2h6.2V29L224.8,41.9z  M252.9,24.1c0-6.3-3.2-8.7-9.8-8.7c-4.1,0-7.3,1.3-9.2,2.4V23c1.7-1.2,5.3-2.6,8.5-2.6c3,0,4.3,1,4.3,3.8v1.5h-1 c-9.5,0-13.7,3.1-13.7,8.4s3.2,8.3,8,8.3c3.6,0,5.2-1.2,6.4-2.4h0.3c0.1,0.7,0.3,1.6,0.5,2.1h6c-0.2-2.1-0.3-4.3-0.3-6.4V24.1z  M246.7,35.7c-0.8,1.1-2.2,2.1-4.4,2.1c-2.6,0-3.9-1.6-3.9-3.9c0-3.1,2.1-4.2,7.4-4.2h0.9V35.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYandexDelivery);
export default __webpack_public_path__ + "static/media/yandex_delivery.751e9543d73d4752c42bfe9fd36709cb.svg";
export { ForwardRef as ReactComponent };